export default __webpack_public_path__ + "static/media/tim_vector.f969b265.jpe";